// Flow types automatically removed

import * as tracking from 'dibs-tracking';
export const trackPageview = () => {
    tracking.trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: 'Other',
        },
    });
};
